<template>
  <div class="page-news">
    <div class="g-wrap">
      <el-breadcrumb class="g-breadcrumb" separator="/">
        <el-breadcrumb-item :to="`${$subsitePrefix}/achievement`"
          >成果转化</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="`${$subsitePrefix}/achievement/industry`"
          >产业供需</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ metaData.name }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="g-content news-content" v-loading="loading">
        <column-header2 :data="metaData"></column-header2>
        <ic-news :data="columnData" :type="metaData.type"></ic-news>
        <el-pagination
          v-if="total > pageSize"
          class="g-pagination"
          background
          layout="prev, pager, next"
          :current-page="pageIndex"
          :page-size="pageSize"
          :total="total"
          @current-change="handleIndexChange"
        >
          ></el-pagination
        >
      </div>
    </div>
  </div>
</template>

<script>
import { getData } from "api/app";
import News from "_c/News";
import ColumnHeader from "_c/ColumnHeader2";
import { mapState } from "vuex";

export default {
  data() {
    return {
      loading: false,
      metaData: { name: "惠企政策" },
      columnData: [],
      name: null,
      total: 0,
      pageSize: 10,
      pageIndex: 1
    };
  },
  computed: {
    ...mapState("college", ["collegeData"])
  },
  created() {
    this.init();
  },
  components: {
    [News.name]: News,
    [ColumnHeader.name]: ColumnHeader
  },
  watch: {
    $route() {
      this.init();
    }
  },
  methods: {
    handleIndexChange(index) {
      this.pageIndex = index;
      this.loadData();
    },
    loadData() {
      const linkDecorator = item => {
        item.link =
          this.$subsitePrefix +
          `/achievement/prefer-firm-detail/PreferentialPolicies?id=${item.id}`;
        return item;
      };
      this.loading = true;
      let params = [
        { Key: "College", Value: this.collegeData.cid, CompareType: "EqualTo" }
      ];
      var queryParams = {
        name: this.name,
        index: this.pageIndex,
        size: this.pageSize ?? 10,
        params
      };
      getData(queryParams)
        .then(res => {
          const arr = [];
          if (res.Data) {
            res.Data.forEach(el => {
              arr.push({
                Headline: el.Headline,
                IssueTime: el.PublishTime,
                Summary: el.Summary,
                Illustration: el.Illustration,
                id: el.Id,
                name: this.name
              });
            });
          }
          this.columnData = (arr || []).map(linkDecorator);
          this.total = res.TotalCount;
          this.loading = false;
        })
        .catch(err => {
          console.log(err);
          this.loading = false;
        });
    },
    init() {
      this.name = this.$route.params.name;
      this.loadData();
    }
  }
  // methods: {
  //   loadData() {
  //     getData({ name: this.name }).then(res => {
  //       const arr = []
  //       res.forEach(el => {
  //         arr.push({
  //           Headline: el.Headline,
  //           IssueTime: el.PublishTime,
  //           Summary: el.Summary,
  //           Illustration: el.Illustration,
  //           id: el.Id,
  //           name: this.name
  //         })
  //       });
  //       this.columnData = (arr || []).map(linkDecorator);
  //     });
  //   },
  //   init() {
  //     this.name = this.$route.params.name;
  //     this.loadData();
  //   }
  // }
};
</script>

<style lang="scss" scoped>
.page-news {
  background: #f6f6f9;
  padding-bottom: 40px;
  ::v-deep .comp-news {
    padding: 5px 0 20px 0;
  }
  .news-content {
    padding-bottom: 40px;
    ::v-deep .comp-column-header {
      padding: 0;
    }
  }
}
</style>
